import { useContext } from "react";
import { ModalContext } from "../components/HOCs/openModal";

export function useModal() {
  return useContext(ModalContext);
}
